import { render, staticRenderFns } from "./two-factor.vue?vue&type=template&id=6bc5b5cc&scoped=true"
import script from "./two-factor.vue?vue&type=script&lang=js"
export * from "./two-factor.vue?vue&type=script&lang=js"
import style0 from "./two-factor.vue?vue&type=style&index=0&id=6bc5b5cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc5b5cc",
  null
  
)

export default component.exports